function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * One Arcade game tile.
 * Holds a Game and renders it. Click → this.game.onClick().
 */
var Teaser = /*#__PURE__*/function () {
  function Teaser(app, arcade) {
    var game = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, Teaser);
    this.app = app;
    this.arcade = arcade;
    this.game = game;
    this.is_add_game = !!opts.is_add_game;
    this.el = null;
  }
  return _createClass(Teaser, [{
    key: "returnClassList",
    value: function returnClassList() {
      var _this$game, _this$game2;
      var classes = ['teaser'];
      if (this.is_add_game) {
        classes.push('add');
      } else if (((_this$game = this.game) === null || _this$game === void 0 || (_this$game = _this$game.game_mod) === null || _this$game === void 0 ? void 0 : _this$game.teaser) === true || ((_this$game2 = this.game) === null || _this$game2 === void 0 || (_this$game2 = _this$game2.game_mod) === null || _this$game2 === void 0 ? void 0 : _this$game2.is_teaser) === true) {
        classes.push('install');
      }
      return classes.join(' ');
    }
  }, {
    key: "renderHTML",
    value: function renderHTML() {
      var _this$game3, _this$game4, _this$game5, _this$game6, _this$game7, _this$game8;
      if (this.is_add_game) {
        return "\n        <div role=\"button\" tabindex=\"0\" class=\"".concat(this.returnClassList(), "\" aria-label=\"Add Game\">\n          <div class=\"art\" aria-hidden=\"true\"></div>\n          <div class=\"title\"><span>+ Add Game</span></div>\n          <div class=\"footer\"></div>\n        </div>\n      ");
      }
      var title = ((_this$game3 = this.game) === null || _this$game3 === void 0 ? void 0 : _this$game3.title) || '';
      var image = ((_this$game4 = this.game) === null || _this$game4 === void 0 ? void 0 : _this$game4.image) || '';
      var name = ((_this$game5 = this.game) === null || _this$game5 === void 0 ? void 0 : _this$game5.name) || '';
      var league_id = ((_this$game6 = this.game) === null || _this$game6 === void 0 ? void 0 : _this$game6.league_id) || '';
      var art_style = image ? " style=\"background-image: url('".concat(image, "')\"") : '';
      var is_install = ((_this$game7 = this.game) === null || _this$game7 === void 0 || (_this$game7 = _this$game7.game_mod) === null || _this$game7 === void 0 ? void 0 : _this$game7.teaser) === true || ((_this$game8 = this.game) === null || _this$game8 === void 0 || (_this$game8 = _this$game8.game_mod) === null || _this$game8 === void 0 ? void 0 : _this$game8.is_teaser) === true;
      var install_label = is_install ? "<span class=\"install-label\">INSTALL</span>" : '';
      return "\n      <div role=\"button\" tabindex=\"0\"\n        class=\"".concat(this.returnClassList(), "\"\n        data-id=\"").concat(name, "\"\n        data-league=\"").concat(league_id, "\">\n        <div class=\"art\"").concat(art_style, " aria-hidden=\"true\"></div>\n        <div class=\"title\"><span>").concat(title, "</span></div>\n        <div class=\"footer\">").concat(install_label, "</div>\n      </div>\n    ");
    }
  }, {
    key: "bind",
    value: function bind(el) {
      var _this = this;
      this.el = el;
      if (!this.el) {
        return;
      }
      var activate = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                e.preventDefault();
                e.stopPropagation();
                _context.n = 1;
                return _this.onClick();
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function activate(_x) {
          return _ref.apply(this, arguments);
        };
      }();
      this.el.onclick = activate;
      this.el.onkeydown = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          activate(e);
        }
      };
    }
  }, {
    key: "onClick",
    value: function () {
      var _onClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.is_add_game) {
                _context2.n = 1;
                break;
              }
              this.app.connection.emit('arcade-add-game');
              return _context2.a(2);
            case 1:
              if (!(this.game && typeof this.game.onClick === 'function')) {
                _context2.n = 2;
                break;
              }
              _context2.n = 2;
              return this.game.onClick();
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }]);
}();
module.exports = Teaser;